
seedWebServices.service('StoreService', ['$http', '$cacheFactory', '$uibModal', 'ToastService', 'WorkflowService', '$rootScope',
    function ($http, $cacheFactory, $uibModal, ToastService, WorkflowService, $rootScope) {

        var serviceCache = $cacheFactory('StoreService');

        var URL = '../Api/StoreApi/';

        this.resetCache = function () {
            //console.log('StoreServiceResetCache');
            serviceCache.removeAll();
        };

        this.getOrders = function (contactID, filterID, orderType, skip) {
            var cache = serviceCache;
            var actionTag = 'Orders';
            return $http.get(URL, {
                params: { actionTag: actionTag, id: contactID, filterID: filterID, orderType: orderType, skip: skip },
                cache: cache
            });
        };

        //START SALESORDERS
        this.getUserOrders = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            //console.log('getUserOrders: ' + filterString);
            return $http.put(URL + '/SearchUserOrders', {
                filterString: filterString,
                options: options,
                skipNumber: skipNumber,
                takeNumber: takeNumber,
                sort: sort,
                parentFilter: parentFilter
            }, { cache: serviceCache });
        };


        this.getUserOrdersColumns = function (column, filterString, skipSize, takeSize, parentFilter, searchString, options) {
            //console.log('storeService.getUserOrderColumns');
            return $http.put(URL + '/GetUserOrdersColumns',
                {
                    column: column,
                    filterString: filterString,
                    skipSize: skipSize,
                    takeSize: takeSize,
                    parentFilter: parentFilter,
                    searchString: searchString,
                    options: options
                },
                { cache: serviceCache }
            );
            /*
            return $http.get(URL + '/GetUserOrdersColumns', {
                params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize, parentFilter: parentFilter },
                cache: serviceCache
            });
            */
        };


        this.getUserOrder = function (orderID) {
            return $http.put(URL + '/SearchUserOrders', {
                skipNumber: 0, takeNumber: 1,
                orderID: orderID
            }, { cache: serviceCache });
        };

        this.getOrderInvoices = function (yearMonths) {
            return $http.put(URL + 'GetOrderInvoices', yearMonths, { cache: true });
        };

        this.getOrdersYearMonths = function () {
            return $http.get(URL + 'GetOrdersYearMonths', {
                params: {},
                cache: serviceCache
            });
        };

        //START SALESORDERS
        this.getUserOrdersArchived = function (filterString, options, skipNumber, takeNumber, sort, contactId) {
            //console.log('getUserOrdersArchived');
            return $http.put(URL + '/SearchUserOrders', {
                filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort,
                contactID: contactId,
                showArchived: true,
            }, { cache: serviceCache });
        };

        //this.getOrdersContact = function (filterString, options, skipNumber, takeNumber, sort, contactID) {
        //    console.log('getOrdersContact ' + contactID);
        //    return $http.put(URL + '/SearchUserOrders', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, contactID: contactID }, { cache: serviceCache });
        //};

        this.getUserOrdersCount = function () {
            return $http.get(URL + '/GetUserOrdersCount', {
                params: {},
                cache: serviceCache
            });
        };



        //END SALESORDERS

        //START SALESORDERDETAILS
        /*
        this.searchOrderDetails = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + '/SearchOrderDetails', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
        }

        this.getOrderDetailsCount = function () {
            return $http.get(URL + '/GetOrderDetailsCount', {
                params: {},
                cache: serviceCache
            });
        };

        this.getOrderDetailsColumns = function (column, filterString, skipSize, takeSize) {
            return $http.get(URL + '/GetOrderDetailsColumns', {
                params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize  },
                cache: serviceCache
            });
        };
        */
        //END SALESORDERDETAILS


        //START SAPITENS
        this.searchSapItems = function (filterString, options, skipNumber, takeNumber, sort, sapOrderID) {
            return $http.put(URL + '/SearchSapItems', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, sapOrderID: sapOrderID }, { cache: serviceCache });
        }

        this.searchSapOrders = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + '/SearchSapOrders', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
        }

        this.getSapItemsCount = function () {
            return $http.get(URL + '/GetSapItemsCount', {
                params: {},
                cache: serviceCache
            });
        };

        this.getSapOrdersCount = function () {
            return $http.get(URL + '/GetSapOrdersCount', {
                params: {},
                cache: serviceCache
            });
        };

        this.getSapItemsColumns = function (column, filterString, skipSize, takeSize) {
            return $http.get(URL + '/GetSapItemsColumns', {
                params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
                cache: serviceCache
            });
        };
        //END SAPITENS

        this.sendCuposSlack = function (contactID) {
            return $http.get(URL + '/CuposSlack', {
                params: { contactID: contactID },
                cache: serviceCache
            });
        };

        this.getMaterialsByBrand = function (brandID) {
            var cache = serviceCache;
            return $http.get(URL + '/MaterialsByBrand', {
                params: { brandID: brandID },
                cache: cache
            });
        };

        this.getMaterials = function (filterString) {
            var cache = serviceCache;
            return $http.get(URL + '/GetMaterials', {
                params: { filterString: filterString },
                cache: cache
            });
        };


        this.loadUser = function (userID) {
            var cache = serviceCache;
            return $http.get(URL + '/LoadUser', {
                params: { userID: userID },
                cache: cache
            });
        }


        this.loadContacts = function (scope, userID) {
            scope.loadingContacts = true;
            scope.loadingMsg = 'Pedidos e Cupos';
            if (!userID) {
                scope.loadingContacts = false;
                return;
            }
            this.loadUser(userID)
                .then(function (result) {
                    scope.loadingContacts = false;
                    scope.error = false;
                    scope.contacts = result.data.Contacts;
                    scope.daySummary = result.data.DaySummary;
                    scope.expired = result.data.Expired;
                    scope.periods = result.data.Periods;
                    scope.summary = result.data.Summary;
                })
                .catch(function (errorDescription) {
                    scope.loadingContacts = false;
                    scope.success = false;
                    scope.error = true;
                    scope.errorDescription = errorDescription;
                    ToastService.createToast('Erro ao carregar clientes', '', 8000, 'error');
                });
        };

        //
        // CONTACT ORDERS
        this.getContactOrdersCount = function (contactID) {
            return $http.get(URL + '/GetContactOrdersCount', {
                params: {},
                cache: serviceCache
            });
        };

        this.getContactOrders = function (contactID, filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + '/SearchContactOrders',
                { contactID: contactID, filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
                { cache: serviceCache });
        };

        this.getContactDashboard = function (contactID) {
            return $http.put(URL + '/GetContactDashboard',
                { contactID: contactID },
                { cache: serviceCache });
        };

        this.getOrderDetails = function (orderID) {
            return $http.get(URL + '/GetOrderDetails', {
                params: { orderID: orderID }
            });
        };

        this.getDashboardOrders = function () {
            return $http.get(URL + '/GetDashboardOrders',
                { cache: serviceCache });
        };


        this.clearErrors = function (order) {
            order.formErrors = [];
        };

        this.addError = function (order, errorMsg) {
            order.formErrors.push({ Msg: errorMsg });
        };

        this.getSumQuantities = function (quantities) {
            if (!quantities) {
                return 0;
            }
            var qt = 0;
            for (var i = 0; i < quantities.length; i++) {
                qt += quantities[i].Quantity;
            }
            return qt;
        };

        this.ValidateOrder = function (order) {
            //Verificar se peças foram selecionadas...

            this.clearErrors(order);
            if (!order.ContactID) {
                this.addError(order, 'Falta selecionar o Cliente ');
            }

            //if (!order.ProductID) {
            //    $scope.addError('Tipo produto não selecionado!');
            //}
            //if (!$scope.expirationdate) {
            //    $scope.addError('Validade CR do cliente está vencida!');
            //}

            //console.log('ValidateOrder');

            var numItens = 0;
            for (var i = 0; i < order.Details.length; i++) {
                var detail = order.Details[i];
                //if (detail.QtMissing > 0) {
                //    this.addError(order, 'Material ' + detail.MaterialID + ' gerando estoque negativo: -' + detail.QtMissing);
                //}
                if (detail.MaterialID) {
                    if (detail.MaterialID && detail.Quantity <= 0) {
                        this.addError(order, 'Material ' + detail.MaterialID + ' com quantidade zero');
                    }


                    /*
                    else {
                        var qt = this.getSumQuantities(detail.Quantities);
                        if (qt <= 0) {
                            this.addError(order, 'Material ' + detail.MaterialID + ': quantidades por mês não calculadas');
                        }                        
                    }
                    */
                    //else if (detail.Material.c_QtStocksFinal < 0) {
                    //    this.addError(order, 'Material ' + detail.MaterialID + ' gerando estoque negativo: ' + detail.Material.c_QtStocksFinal);
                    //}

                    numItens++;
                }
            }

            if (numItens <= 0) {
                this.addError(order, 'Nenhum material preenchido');
            }

            //if (order.OrderValue <= 0) {
            //    $scope.addError('Valor do pedido deve ser maior que zero!');
            //}

            return order.formErrors.length <= 0;
        };


        this.saveOrder = function (order) {
            return $http.put(URL + '/SaveOrder', order);
        };

        this.saveOrderChanges = function (order) {
            /*
            var data = {
                orderID: orderID,
                details: details,
                info: info
            };
            */
            return $http.put(URL + '/SaveOrderChanges', order);
        };

        this.recalcExpired = function () {
            return $http.put(URL + '/RecalcExpired', {
                params: {},
                cache: false
            });
        };

        this.renovateExpired = function (orderID) {
            return $http.put(URL + '/RenovateExpired', {
                orderID: orderID,
            });
        };

        this.openOrderDetailModal = function (orderID, contactID, cartOrder, openTab) {
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/OrderDetailModal.html' + seedWebApp.buildVersion,
                controller: 'OrderDetailCtrl',
                size: 'xl',
                resolve: {
                    orderID: function () {
                        return orderID;
                    },
                    contactID: function () {
                        return contactID;
                    },
                    cartOrder: function () {
                        return cartOrder;
                    },
                    openTab: function () {
                        return openTab;
                    },
                }
            });
            return modalInstance;
        };

        this.getOrderEvents = function (orderID) {
            return $http.get(URL + '/GetOrderEvents', {
                params: { orderID: orderID },
                cache: serviceCache
            });
        };

        this.getContacts = function () {
            return $http.get(URL + '/GetContacts', {
                params: {},
                cache: serviceCache
            });
        };



        this.saveExpiredJustification = function (orderID, expiredJustification) {
            var data = {
                orderID: orderID,
                expiredJustification: expiredJustification,
            };
            return $http.put(URL + '/SaveExpiredJustification', data);
        };


        this.requestRenovateExpired = function (orderID, renovateReason) {
            var data = {
                orderID: orderID,
                renovateReason: renovateReason,
            };
            return $http.put(URL + '/RequestRenovateExpired', data);
        };

        this.refuseRenovateExpired = function (orderID) {
            var data = {
                orderID: orderID,
            };
            return $http.put(URL + '/RefuseRenovateExpired', data);
        };

        this.notifyOrderUpdated = function (orderID) {
            $rootScope.$broadcast('onOrderUpdated', orderID);
        };


        this.getHints = function () {
            return $http.get(URL + '/GetHints', {
                params: {},
                cache: serviceCache
            });
        };

        this.rejectHint = function (hint) {
            return $http.put(URL + '/RejectHint', hint);
        };


        this.getOrdersReconcile = function (filterString) {
            return $http.get(URL + '/GetOrdersReconcile', {
                params: { filterString: filterString },
                cache: serviceCache
            });
        };

        this.getCountryImage = function (country) {
            return '/Images/flags/' + country + '.png';
        };

        this.getStatus = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + '/GetStatus',
                { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
                { cache: serviceCache }
            );
        };

        this.getStatusCount = function () {
            return $http.get(URL + '/GetStatusCount', {
                cache: false
            });
        };

        this.saveStatus = function (status) {
            return $http.put(URL + '/SaveStatus', status, true);
        };

        this.getProcExps = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + '/GetProcExps',
                { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
                { cache: serviceCache }
            );
        };

        this.getProcExpsCount = function () {
            return $http.get(URL + '/GetProcExpsCount', {
                cache: false
            });
        };

        this.getExpenses = function (id) {
            return $http.get(URL + '/GetExpenses', {
                params: { id: id },
                cache: false
            });
        };


        this.recalcShippingSchedule = function () {
            return $http.put(URL + '/RecalcShippingSchedulePending', {
                params: {},
                cache: false
            });
        };

        this.configureColumnLayout = function (columns) {
            return $http.put(URL + '/ConfigureColumnLayout', { columns: columns });
        };

        this.getConfigurationColumnLayout = function () {
            return $http.get(URL + '/ConfigureColumnLayout');
        };

        this.recalcOrder = function (orderID) {
            return $http.put(URL + '/RecalcOrderShippingSchedule', { orderID: orderID });
        };



        this.searchQuotes = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + '/SearchQuotes', {
                filterString: filterString,
                options: options,
                skipNumber: skipNumber,
                takeNumber: takeNumber,
                sort: sort,
                parentFilter: parentFilter
            }, { cache: serviceCache });
        };

        this.getQuotesColumns = function (column, filterString, skipSize, takeSize, parentFilter) {
            return $http.put(URL + '/GetQuotesColumns',
                {
                    column: column,
                    filterString: filterString,
                    skipSize: skipSize,
                    takeSize: takeSize,
                    parentFilter: parentFilter,
                },
                {
                    cache: serviceCache
                }
            );

            /*
            return $http.put(URL + '/GetUserOrdersColumns',
                {
                    column: column,
                    filterString: filterString,
                    skipSize: skipSize,
                    takeSize: takeSize,
                    parentFilter: parentFilter,
                    searchString: searchString,
                    options: options
                },
                { cache: serviceCache }
            );
            */
        };

        this.getEmptyContainers = function (contactID, searchString) {
            return $http.get(URL + '/GetEmptyContainers', {
                params: { contactID: contactID, searchString: searchString },
                cache: false
            });
        };

        /*
        this.getQuotes = function (contactID, searchString) {
            return $http.get(URL + '/GetQuotes', {
                params: { contactID: contactID, searchString: searchString },
                cache: false
            });
        };
        */

        this.recalcTotals = function (order) {
            var total = 0;
            var totalWoTariff = 0;
            var totalM3 = 0;
            var lastSeq = 0;
            var totalContainers = 0;
            var totalDesc = 0;
            var hasDiscounts = false;
            var totalWeight = 0;
            for (var i in order.Details) {
                var detail = order.Details[i];
                this.recalcDetail(order, detail); //Por causa dos preços
                if (order.Details[i].SeqID && order.Details[i].SeqID.toString().endsWith('00')) {
                    total += order.Details[i].PriceAmount;
                    totalWoTariff += order.Details[i].PriceAmountWoTariff || 0;

                    if (this.isFullContainer(order, detail)) {
                        totalDesc += order.Details[i].PriceAmountDesc;
                        hasDiscounts = true;
                    }
                    else {
                        totalDesc += order.Details[i].PriceAmount;
                    }
                    if (Number(detail.SeqID) > lastSeq) {
                        lastSeq = Number(detail.SeqID);
                    }
                    totalContainers += this.getPercContainer(detail);
                }

                totalM3 += order.Details[i].QtM3;
                totalWeight += Number(detail.peso_real);
            }
            order.HasDiscounts = hasDiscounts;
            order.TotalAmount = total;
            order.TotalAmountWoTariff = totalWoTariff;
            order.TotalAmountDesc = totalDesc;
            order.TotalVolume = totalM3;
            order.LastSeqID = lastSeq;
            order.TotalContainers = totalContainers;
            order.Containers = this.splitContainers(order);
            order.TotalWeight = totalWeight;
        };

        this.splitContainers = function (order) {
            var containers = [];
            if (order.TotalContainers) {
                var tot = order.TotalContainers;
                if (tot <= 100) {
                    containers.push(
                        {
                            id: 0,
                            perc: tot
                        });
                }
                else {
                    var num = Math.trunc(tot / 100);
                    for (var i = 0; i < num; i++) {
                        containers.push(
                            {
                                id: 0,
                                perc: 100
                            });
                    }
                    if (num >= 1) {
                        var perc = tot - (100 * num - 1)
                        containers.push(
                            {
                                id: 0,
                                perc: perc
                            });
                    }
                }
            }
            return containers;
        };


        this.MIN_STRAIGHT_LOAD_REF_CODE = 100;

        this.refCodeAllowsDiscount = function (detail) {
            if (detail.RefCode) {
                var strRefCode = detail.RefCode.replace(",", "."); //trata decimais
                var numRefCode = Number(strRefCode);
                if (numRefCode < this.MIN_STRAIGHT_LOAD_REF_CODE) {
                    //console.log('isFullContainer numRefCode below: ' + numRefCode);
                    detail.MsgDiscountDenied = 'RefCode bellow minimum';
                    return false;
                }
                else {
                    if (detail.VlPriceDesc <= 0) {
                        detail.MsgDiscountDenied = 'Discount ZERO';
                        return false;
                    }
                    else if (detail.VlPriceDesc == detail.UnitPrice) {
                        detail.MsgDiscountDenied = 'Discount equal to price'
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
            return false;
        };

        //VERIFICAR SOMA DOS MESMOS DESENHOS
        this.isFullContainer = function (order, detail) {
            //console.log('isFullContainer ' + detail.SkuID);

            //REGRA FULL CONTAINER APENAS SE REFCODE >= 100
            if (detail.RefCode) {
                var strRefCode = detail.RefCode.replace(",", "."); //trata decimais
                var numRefCode = Number(strRefCode);
                if (numRefCode < this.MIN_STRAIGHT_LOAD_REF_CODE) {
                    return false;
                }
            }
            if (!detail.DrawingID) {
                return false;
            }
            var qtFullContainer = order.Details.reduce(function (max, item) {
                if (item.DrawingID == detail.DrawingID && item.QtdTotalContainer > max) {
                    return item.QtdTotalContainer;
                }
                return max;
            }, 0);
            var qtDrawings = order.Details.reduce(function (tot, item) {
                if (item.DrawingID == detail.DrawingID) {
                    return tot + item.Quantity;
                }
                return tot;
            }, 0);
            if (qtFullContainer) {
                return qtDrawings >= qtFullContainer;
            }
            else {
                return false;
            }
        };

        this.isEditingOrInserting = function (order) {
            return order.isEditing || order.isInserting;
        };

        this.recalcDetail = function (order, detail) {
            //JRM: RECALC AMMOUNT
            if (this.isEditingOrInserting(order)) {
                detail.Quantity = detail.QtBoxes * detail.pc_cx_un_cli;
            }

            detail.PriceAmount = detail.Quantity * detail.UnitPrice;
            detail.PriceAmountWoTariff = detail.Quantity * (detail.UnitPriceWoTariff || 0);

            if (this.isFullContainer(order, detail)) {
                detail.PriceAmountDesc = detail.Quantity * detail.VlPriceDesc;
            }
            else {
                detail.PriceAmountDesc = 0;
            }

            if (detail.PriceUnitID == 'CLF') {
                detail.PriceAmount = detail.PriceAmount / 100;
                detail.PriceAmountWoTariff = detail.PriceAmountWoTariff / 100;
                detail.PriceAmountDesc = detail.PriceAmountDesc / 100;
            }
            //ctrl.onRecalcTotals(order);            
        };

        this.getPercContainer = function (detail) {
            if (detail.volume_m3_mbf) {
                return detail.volume_m3_mbf * detail.QtBoxes / 22 * 100;
                //return detail.volume_m3_mbf * detail.Quantity / 22 * 100;
            }
            else {
                return 0;
            }
        };

        this.acceptOrder = function (order) {
            return $http.put(URL + '/AcceptOrder',
                order,
                { cache: serviceCache }
            );
        };

        this.isQuote = function (order) {
            if (order && order.OrderID) {
                if (order.OrderID.startsWith('TSW')) {
                    return true;
                }
                else if (order.OrderID == 'NEW_QUOTE') {
                    return true;
                }
            }
            return false;
        };

        this.getQuoteOrders = function (orderID) {
            return $http.get(URL + '/GetQuoteOrders', {
                params: { orderID: orderID },
                cache: false
            });
        };

        this.cancelOrder = function (orderID, cancelReason) {
            var data = {
                orderID: orderID,
                cancelReason: cancelReason,
            };
            this.resetCache();
            return $http.put(URL + '/CancelOrder',
                data,
                { cache: serviceCache }
            );
        };

        this.completeQuote = function (orderID, completeComments) {
            var data = {
                orderID: orderID,
                completeComments: completeComments,
            };
            this.resetCache();
            return $http.put(URL + '/CompleteQuote',
                data,
                { cache: serviceCache }
            );
        };


        this.startIntegrationShipping = function () {
            var data = {
                integrationID: '0-SHIPPING',
            };
            this.resetCache();
            return $http.put(URL + '/StartIntegration',
                data,
                { cache: serviceCache }
            );
        };

        this.getSitPortalClass = function (sitPortal, statusID) {
            if (statusID) {
                if (statusID > '10_PRE_SALE') {
                    return 'status-card Status_' + statusID;
                }
            }
            switch (sitPortal) {
                case 1: return 'btn-default';
                case 2: return 'sit-portal-rejeitado';
                case 3: return 'sit-portal-cancelado'; //cancelado
                case 4: return 'sit-portal-waiting';
                case 5: return 'sit-portal-aceito';
                case 6: return 'sit-portal-efetivado';
            }
        };

        this.isAcceptedOrRejected = function (order) {
            if (!order) {
                return false;
            }
            return order.sit_portal == 5 || order.sit_portal == 2 || order.sit_portal == 6 || order.sit_portal == 3;
        };

        this.getFavorites = function (contactID) {
            return $http.get(URL + '/GetFavorites', {
                params: {
                    contactID: contactID,
                },
                cache: serviceCache
            });
        };

        this.saveFavorite = function (favorite) {
            this.resetCache();
            return $http.put(URL + '/SaveFavorite', favorite);
        };

        this.deleteFavorite = function (favorite) {
            this.resetCache();
            return $http.put(URL + '/DeleteFavorite', favorite);
        };

        this.addFavoriteSku = function (favoriteID, skuID) {
            this.resetCache();
            var data = {
                favoriteID: favoriteID,
                skuID: skuID,
            };
            return $http.put(URL + '/AddFavoriteSku', data);
        };

        this.removeFavoriteSku = function (favoriteID, skuID) {
            this.resetCache();
            var data = {
                favoriteID: favoriteID,
                skuID: skuID,
            };
            return $http.put(URL + '/RemoveFavoriteSku', data);
        };

        this.saveSentNotification = function (event) {
            this.resetCache();
            var data = {
                EventID: event.EventID,
                SentNotification: event.SentNotification,
            };
            return $http.put(URL + '/SaveSentNotification', data);
        };

        this.getDefaultDateFormat = function () {
            return 'MMM dd, yyyy';
        };

        this.getStatusList = function (filter) {
            return $http.get(URL + '/GetStatusList', {
                params: {
                    filter: filter,
                },
                cache: serviceCache
            });
        };

        this.getStatusChangeable = function (orderID) {
            return $http.get(URL + '/GetStatusChangeable', {
                params: {
                    orderID: orderID,
                },
                cache: serviceCache
            });
        };

        this.addCartProduct = function (cartOrder, cartProduct, currencySymbol) {
            //console.log('storeService.addCartProduct: ')

            var newDetail = null;
            if (!cartProduct.PointID) {
                ToastService.createToast('Error', 'Produto sem pto chegada, cadastro incompleto: ' + cartProduct.SkuID, 4000, 'error');
                return false;
            }

            var lastID = cartOrder.LastSeqID;
            if (lastID) {
                lastID = String(Number(lastID) + 100);
            }
            else {
                lastID = '100';
            }
            var pc_cx_un_cli = cartProduct.pc_cx_un_cli;
            if (!pc_cx_un_cli || pc_cx_un_cli == 0) {
                pc_cx_un_cli = 1; //Quantidade minima por caixas = 1 unidade
            }

            cartOrder.isInserting = true;
            cartOrder.CurrencySymbol = currencySymbol;

            //Verifica se ja existe
            var detailFound = null;
            for (var i in cartOrder.Details) {
                var det = cartOrder.Details[i];
                if (det.SkuID == cartProduct.SkuID && det.PointID == cartProduct.PointID) {
                    detailFound = det;
                }
            }
            if (detailFound) {
                detailFound.QtBoxes++;
                this.recalcDetail(cartOrder, detailFound);
                newDetail = detailFound;
            }
            else {
                newDetail = {
                    SeqID: lastID,
                    SkuID: cartProduct.SkuID,
                    SkuName: cartProduct.SkuName,
                    MaterialID: cartProduct.MaterialID,
                    MaterialName: cartProduct.MaterialName,
                    RefCode: cartProduct.ReferID,
                    //TESTE ERRO SEM DESENHO
                    DrawingID: cartProduct.DrawingID,
                    StatusID: WorkflowService.getStatusNewQuote(),
                    QtBoxes: 1,
                    Quantity: 0,
                    QuantityDelivered: 0,
                    MatThickness: cartProduct.SkuThickness,
                    MatWidth: cartProduct.SkuWidth,
                    MatLength: cartProduct.SkuLength,
                    UnitID: cartProduct.UnitID,
                    PriceUnitID: cartProduct.PriceUnitID,
                    UnitPrice: cartProduct.ItemsPrice,
                    UnitPriceWoTariff: cartProduct.VlPriceSRecipr,
                    PriceDescWoTariff: cartProduct.VlPriceDescSRecipr,
                    pc_cx_un_cli: pc_cx_un_cli,
                    it_codigo_impar: cartProduct.it_codigo_impar,

                    PointID: cartProduct.PointID,
                    PointName: cartProduct.PointName,

                    //JRM PARA MOSTRAR NA LISTA
                    fator: cartProduct.fator,
                    ItemsPrice: cartProduct.ItemsPrice,
                    VlPriceSRecipr: cartProduct.VlPriceSRecipr,
                    SkuThickness: cartProduct.SkuThickness,
                    SkuWidth: cartProduct.SkuWidth,
                    SkuLength: cartProduct.SkuLength,
                    VlPriceDesc: cartProduct.VlPriceDesc,
                    volume_m3_mbf: cartProduct.volume_m3_mbf,
                    QtdTotalContainer: cartProduct.QtdTotalContainer,
                    qtd_min_container: cartProduct.qtd_min_container,
                    VlMbfBase: cartProduct.VlMbfBase,
                    VlMbfFinal: cartProduct.VlMbfFinal,

                    //NrPacks: cartProduct.pc_cx_un_cli,

                    qt_m3: cartProduct.qt_m3,
                    EDD: new Date(),
                    Boxes: []
                }
                //JRM: RECALC AMMOUNT
                newDetail.PriceAmount = newDetail.Quantity * newDetail.UnitPrice;
                this.recalcDetail(cartOrder, newDetail);
                cartOrder.Details.push(newDetail);
                //console.log('addCartProduct', newDetail);
            }
            this.recalcTotals(cartOrder);
            return newDetail;
        };

        this.getPermissions = function (moduleName) {
            return $http.get(URL + '/GetPermissions', {
                params: {
                    moduleName: moduleName,
                },
                cache: serviceCache
            });
        };

        this.getContactAddresses = function (contactID) {
            return $http.get(URL + '/GetContactAddresses', {
                params: {
                    contactID: contactID,
                },
                cache: serviceCache
            });
        };

        this.getDrawingID = function (item) {
            //pegar ultimos 4 caracteres
            if (item) {
                return item.slice(-4);
            }
            else {
                return null;
            }
        };
    }

]);
